<template>
  <FetchJson :url="url" @fetched="onDataFetched">
    <InfoBlock>
      <template v-slot:header>
        Количество документов в ГИСОГД за период
      </template>
      <template v-slot:default>
        <div class="">
          <VueApexCharts
            height="300px"
            type="area"
            :options="chartOptions"
            :series="series"
          ></VueApexCharts>
        </div>
      </template>
    </InfoBlock>
  </FetchJson>
</template>

<script>
import { ref, toRefs, computed } from "vue";
import { dateToString } from "@/modules/date";
import VueApexCharts from "vue3-apexcharts";

export default {
  components: { VueApexCharts },
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const filter = toRefs(props.filter);
    const url = computed(
      () =>
        `gisogd/document-distribution-by-period?from=${dateToString(
          filter.from.value
        )}&to=${dateToString(filter.to.value)}&territory=${
          filter.territory.value.alias || ""
        }`
    );
    const series = ref([]);
    const categories = ref([]);
    const onDataFetched = function (data) {
      series.value = [
        { data: data.series.length ? data.series[0].values : [] },
      ];
      categories.value = data.categories;
    };
    const chartOptions = computed(() => {
      return {
        chart: {
          type: "area",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        tooltip: {
          fixed: {
            enabled: false,
          },
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: function () {
                return "";
              },
            },
          },
          marker: {
            show: false,
          },
        },
        stroke: {
          curve: "straight",
          width: 2,
        },
        plotOptions: {
          bar: {
            borderRadius: 1,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "category",
          categories: categories.value,
          crosshairs: {
            width: 0,
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: ['#465362'],
              fontSize: '16px',
              fontFamily: 'Source Sans Pro, Tahoma, sans-serif',
              fontWeight: 400,
              cssClass: 'apexcharts-yaxis-label',
            },
            align: 'left',
            offsetX: -13,
          },
        },
      };
    });

    return {
      url,
      chartOptions,
      series,
      onDataFetched,
    };
  },
};
</script>
